/**
 * S值相关业务逻辑
 */

import { getS, getSSimple } from '../../utils/getS';
import { mapWeatherValueToType } from '../../utils/getS/weather-mapping';
import {
  getNumberValue,
  getSunriseSunsetTime,
  getCurrentTime
} from '../config-data.utils';
import { DataSourceKey } from '@/resources/enum';

/**
 * 从 configDataWhole 中提取 getS/getSSimple 所需的参数
 */
const getSValueParams = (
  configDataWhole: WatchRendererOptions['configData']
) => {
  if (!configDataWhole) return null;

  const sunTimes = getSunriseSunsetTime(configDataWhole);
  const currentTime = getCurrentTime(configDataWhole);

  if (!sunTimes || !currentTime) return null;

  // 获取天气并转换为 WeatherType
  const weatherValue = getNumberValue(
    configDataWhole,
    'weatherCurrentWeather',
    99
  );
  const weather = mapWeatherValueToType(weatherValue);

  return {
    weather,
    sunriseTime: sunTimes.sunriseTime,
    sunsetTime: sunTimes.sunsetTime,
    currentTime
  };
};

// 计算天色值完整版
export const getSValue = (
  configDataWhole: WatchRendererOptions['configData']
) => {
  if (!configDataWhole) return;

  const params = getSValueParams(configDataWhole);
  if (!params) return;

  const sValue = getS(params);
  configDataWhole[DataSourceKey.tianSeFull] = sValue;
};

// 计算天色值精简版
export const getSSimpleValue = (
  configDataWhole: WatchRendererOptions['configData']
) => {
  if (!configDataWhole) return;

  const params = getSValueParams(configDataWhole);
  if (!params) return;

  const sSimpleValue = getSSimple(params);
  configDataWhole[DataSourceKey.tianseSimple] = sSimpleValue;
};
